import { useState } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { useTranslation } from 'react-i18next'

import Icon from '../../../../../Icons'

const SelectGiftTypeView = ({ onClose = () => {}, onNext = () => {} }) => {
  const { t } = useTranslation(['rewards-gift', 'rewards-table', 'rewards-loyalty', 'common'])
  const [currentType, setCurrentType] = useState('')

  const cardsOptions = [
    {
      name: 'external',
      icon: (
        <Icon
          icon="buy"
          className={'icon-buy'}
          viewBox={'0 0 40 40'}
          svgProps={{ strokeWidth: '0' }}
        />
      ),
      title: t('rewards-gift:selectGiftType.externalGiftCards'),
      tooltipText: t('rewards-gift:selectGiftType.externalGiftCardsTooltip'),
    },
    {
      name: 'amenity',
      icon: (
        <Icon
          icon="homeHeart"
          className={'icon-home-heart'}
          viewBox={'0 0 40 40'}
          svgProps={{
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      ),
      title: t('rewards-table:giftCardsTabs.customAmenity'),
      tooltipText: t('rewards-gift:selectGiftType.customAmenityTooltip'),
    },
    {
      name: 'services',
      icon: (
        <Icon
          icon="gem"
          className={'icon-gem'}
          viewBox={'0 0 40 40'}
          svgProps={{
            strokeWidth: '1.5',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
          }}
        />
      ),
      title: t('rewards-table:giftCardsTabs.customServices'),
      tooltipText: t('rewards-gift:selectGiftType.customServicesTooltip'),
    },
    {
      name: 'link',
      icon: <Icon icon="moneyBag" svgProps={{ strokeWidth: '0' }} />,
      title: t('rewards-gift:selectGiftType.cashRewardLink'),
      tooltipText: t('rewards-gift:selectGiftType.cashRewardLinkTooltip'),
    },
  ]

  return (
    <div>
      <div className="rewards-modal-content">
        <div className="rewards-card-items">
          <span className="rewards-card-items__title">
            {t('rewards-gift:selectGiftType.description')}
          </span>
          <div className="rewards-card-items__wrapper">
            {cardsOptions.map((option) => (
              <div
                onClick={() => setCurrentType(option.name)}
                className={`rewards-card-item ${option.name === currentType ? 'selected' : ''}`}
                key={option.name}
              >
                {option.icon}
                <span>
                  {option.title}
                  <div data-tip data-for={`reward-info-tip-${option.name}`}>
                    <Icon icon="info" className="info" viewBox="0 0 25 25" />
                    <ReactTooltip
                      className="tooltip"
                      id={`reward-info-tip-${option.name}`}
                      multiline
                      place="top"
                    >
                      {option.tooltipText}
                    </ReactTooltip>
                  </div>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onClose}>
          {t('common:actions.cancel')}
        </button>
        <button
          className="button button-primary"
          onClick={() => onNext(currentType)}
          disabled={!currentType}
        >
          {t('rewards-loyalty:activityForm.nextButton')}
        </button>
      </div>
    </div>
  )
}

SelectGiftTypeView.propTypes = {
  onClose: PropTypes.func,
  onNext: PropTypes.func,
  setType: PropTypes.func,
  currentType: PropTypes.string,
}

export default SelectGiftTypeView
